export enum SolverRules {
  OutOfZone = "Resources must only work within assigned zones",
  MissingSkills = "Resources must only be assigned work for which they have the skills",
  ValidSchedule = "The schedule must be feasible",

  // medium

  InvalidResourceLock = "Manually locked tickets must only be done by the locked resource",
  AvailabilityOverrun = "Tickets should not overrun resource availability",
  AppointmentOverrun = "Tickets must not overrun appointment",
  AppointmentBefore = "Tickets must not start before appointment",
  NormalQuota = "Normal Priority Quota Exceeded",
  HighQuota = "High Priority Quota Exceeded",
  EmergencyQuota = "Emergency Priority Quota Exceeded",

  // soft
  TravelTime = "The total travel time between tickets should be minimised",
  WaitingTime = "The total waiting time between tickets should be minimised",
  RTBTime = "Minimise end of shift travel",
  ForceStartIgnored = "The forced start time value requested should be honoured",
  NormalQuotaUse = "Normal Priority Quota Use",
  HighQuotaUse = "High Priority Quota Use",
  EmergencyQuotaUse = "Emergency Priority Quota Use"
}
